import CustomModal from '../../../components/CustomModal';
import CustomModalContent from '../../../components/CustomModal/CustomModalContent';
import CustomModalHeader from '../../../components/CustomModal/CustomModalHeader';
import useModalState from '../../../context/modal/useModalState';
import ClosePosition from './ClosePosition';

const ClosePositionModal = () => {
    const { closeModal } = useModalState();

    const onClose = () => closeModal('closePositionModal');

    return (
        <CustomModal modalName='closePositionModal' className='close-position-modal'>
            <CustomModalHeader title='Close Position' onClose={onClose} />
            <CustomModalContent>
                <ClosePosition onClose={onClose} />
            </CustomModalContent>
        </CustomModal>
    );
};

export default ClosePositionModal;
